{
  "CHAT_LIST": {
    "LOADING": "Henter samtaler",
    "LOAD_MORE_CONVERSATIONS": "Last inn flere samtaler",
    "EOF": "Alle samtaler lastet 🎉",
    "LIST": {
      "404": "Det er ingen aktive samtaler i denne gruppen."
    },
    "FAILED_TO_SEND": "Kunne ikke sende",
    "TAB_HEADING": "Samtaler",
    "MENTION_HEADING": "Omtale",
    "UNATTENDED_HEADING": "Udeltatt",
    "SEARCH": {
      "INPUT": "Søk etter personer, samtaler, lagrede svar .."
    },
    "SEARCH_MESSAGES": "Søk i samtaler",
    "SEARCH_INPUT_PLACEHOLDER": "Søk i samtaler...",
    "FILTER_ALL": "Alle",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Mine",
      "unassigned": "Ikke tildelt",
      "all": "Alle"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Lim inn i svar",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Åpne",
        "BUY": "Kjøp"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Åpne"
      },
      "resolved": {
        "TEXT": "Løst"
      },
      "pending": {
        "TEXT": "Ventende"
      },
      "snoozed": {
        "TEXT": "Slumret"
      },
      "all": {
        "TEXT": "Alle"
      }
    },
    "VIEW_FILTER": "Vis",
    "SORT_TOOLTIP_LABEL": "Sorter samtaler",
    "CHAT_SORT": {
      "STATUS": "Satus",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Created",
      "LAST_ACTIVITY": "Last activity:",
      "LAST_CUSTOMER_MESSAGE": "Siste kundemelding:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Siste kundemelding: Eldste først"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Siste kundemelding: Nyeste først"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Prioritet + Opprettet: Nyeste først"
      },
      "priority_created_at_asc": {
        "TEXT": "Prioritet + Opprettet: Eldste først"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Bildemelding"
      },
      "audio": {
        "CONTENT": "Lydmelding"
      },
      "video": {
        "CONTENT": "Video beskjed"
      },
      "file": {
        "CONTENT": "Vedlegg"
      },
      "location": {
        "CONTENT": "Plassering"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "har delt en URL"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sort by",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Created at",
          "LABEL": "Created at"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Mottatt via e-post",
    "VIEW_TWEET_IN_TWITTER": "Vis tweet i Twitter",
    "REPLY_TO_TWEET": "Svar på denne tweeten",
    "LINK_TO_STORY": "Go to instagram story",
    "SENT": "Sent successfully",
    "READ": "Read successfully",
    "DELIVERED": "Delivered successfully",
    "NO_MESSAGES": "Ingen meldinger",
    "NO_CONTENT": "No content available",
    "HIDE_QUOTED_TEXT": "Hide Quoted Text",
    "SHOW_QUOTED_TEXT": "Show Quoted Text",
    "HIDE_AUTOMATED_MESSAGE": "Skjul innhold i automatisk svar",
    "SHOW_AUTOMATED_MESSAGE": "Vis innhold i automatisk svar",
    "AUTOMATED_MESSAGE": "Automatisk svar",
    "MESSAGE_READ": "Read",
    "SENDING": "Sending"
  }
}
